import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKlushuis = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M20 14h4v18h-4z"
    />
    <path
      fill="#85E3F9"
      d="M27 10v4H17v-4zM17 8v8h-5V8z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKlushuis);

export default ForwardRef;
